import { useEffect, useState, useCallback, useMemo } from 'react'
import { useLocation } from '@truepill/tpos-react-router'
import { SaveButton } from 'components/ActionButton'
import {
  FloatingBoxFormActionButtonContainer,
  FloatingBoxFormColumn,
  FormItems,
  FormItem,
  WideTextInput,
} from 'components/ColumnForm'
import { SinglePanePageContainer } from 'components/PageStructure'
import LoginAuth0Box from 'components/User/Login'
import useSetPageTitle from 'hooks/useSetPageTitle'
import { useToastContext } from 'providers/Overlays/ToastProvider'
import { usePlusClient } from 'providers/VisionRouter'
import { ToastType } from 'types'

const LoginPage = (): JSX.Element => {
  const { loginUser } = usePlusClient()
  const [password, setPassword] = useState('')
  const [username, setUsername] = useState('')
  const { showToast } = useToastContext()
  const location = useLocation() as { state?: { from: { pathname: string } }; search: '' }
  // Commenting instead of remove the next line because it will probably needed to
  // fix the redirect after login feature: JR-5487
  //
  // const { from } = location.state || { from: { pathname: RoutePath.Root } }
  const { search } = location

  useSetPageTitle('Login')

  useEffect(() => {
    const params = new URLSearchParams(search)
    if (params.has('reauthenticate')) {
      params.delete('reauthenticate')
      showToast('Session expired. Please log in again.', ToastType.info)
    }
  }, [showToast, search])

  const attemptLogIn = useCallback(async () => {
    const success = await loginUser(username, password)

    if (!success) {
      showToast('Incorrect username or password', ToastType.error)
    }
  }, [showToast, loginUser, password, username])

  const isProd = useMemo(() => window.location.hostname === 'vision.truepill.com', [])

  return (
    <SinglePanePageContainer data-testid="LoginPage">
      {!isProd && (
        <FloatingBoxFormColumn>
          <h1>Login</h1>
          <FormItems>
            <form>
              <FormItem>
                <p>Username</p>
                <WideTextInput
                  data-testid="username"
                  placeholder={'user.name'}
                  onChange={e => setUsername(e.target.value)}
                  value={username}
                />
              </FormItem>
              <FormItem>
                <p>Password</p>
                <WideTextInput
                  data-testid="password"
                  type={'password'}
                  placeholder={'******'}
                  onChange={e => setPassword(e.target.value)}
                  value={password}
                  onKeyPress={({ key }) => {
                    if (key === 'Enter') {
                      attemptLogIn()
                    }
                  }}
                />
              </FormItem>
              <FloatingBoxFormActionButtonContainer>
                <SaveButton data-testid="do-login" label={'Log in'} onClick={attemptLogIn} />
              </FloatingBoxFormActionButtonContainer>
            </form>
          </FormItems>
        </FloatingBoxFormColumn>
      )}

      <LoginAuth0Box />
    </SinglePanePageContainer>
  )
}

export default LoginPage
